/*
 * Copyright Evollis 2021
 * All Rights Reserved.
 *
 * All information contained herein is, and remains the property of Evollis.
 * The intellectual and technical concepts contained herein are
 * proprietary to Evollis and are protected by trade secret and copyright law.
 * Dissemination of this information or reproduction of this material
 * is STRICTLY FORBIDDEN unless prior written permission is obtained
 * from Evollis.
 */
import { AcceptancePage } from "./AcceptancePage"
import AdyenPaymentValidationPage from "./AdyenPaymentValidationPage"
import AplazameConfirmationPage from "./AplazameConfirmationPage"
import ApzCheckoutPage from "./ApzCheckoutPage"
import CbPage from "./CbPage"
import { ClientPage } from "./ClientPage"
import ComeBackLaterPage from "./ComeBackLaterPage"
import FailPage from "./FailPage"
import FinalPage from "./FinalPage"
import IdentificationPage from "./IdentificationPage"
import LoaderPage from "./LoaderPage"
import MaintenancePage from "./MaintenancePage"
import NetheosPage from "./NetheosPage"
import OnboardingPage from "./OnboardingPage"
import OrderPage from "./OrderPage"
import PaymentKOPage from "./PaymentKOPage"
import PendingScorePage from "./PendingScorePage"
import RouteWithAccessKeys from "./RouteWithAccessKeys"
import { ScoreKOPage } from "./ScoreKOPage"
import ServicesPage from "./ServicePage"
import { SimulationFinalPage } from "./SimulationFinalPage"
import SummaryPage from "./SummaryPage"
import React, { useEffect } from "react"
import ReactGA from "react-ga"
import TagManager from "react-gtm-module"
import { Switch, useLocation } from "react-router-dom"

const ScrollToTop = (props) => {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return props.children
}

export default function EvollisPagesLayout(props) {
  useEffect(() => {
    if (props.tunnelData?.gaConfig?.trackingId) {
      ReactGA.initialize(props.tunnelData.gaConfig.trackingId, {
        gaOptions: {
          allowLinker: true
        }
      })
      ReactGA.pageview(window.location.pathname + window.location.search)
      ReactGA.ga("require", "linker")
      ReactGA.ga("linker:autoLink", [props.tunnelData?.shopUrl])
    }
    if (props.tunnelData?.gtmConfig?.trackingId) {
      TagManager.initialize({
        gtmId: props.tunnelData.gtmConfig.trackingId
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.location.pathname, window.location.search])

  return (
    <>
      {/*Global styles taken from tunnelData. Add on this stylesheet only cross component styles.
        Component scoped styles must be include in this way, but in targetted component.*/}
      <Switch>
        <ScrollToTop>
          <RouteWithAccessKeys
            path="/digital-journey/simulationFinal"
            render={(routeProps) => <SimulationFinalPage {...routeProps} {...props} />}
          />
          <RouteWithAccessKeys
            path="/digital-journey/onboarding"
            render={(routeProps) => <OnboardingPage {...routeProps} {...props} />}
          />
          <RouteWithAccessKeys
            path="/digital-journey/services"
            render={(routeProps) => <ServicesPage {...routeProps} {...props} />}
          />
          <RouteWithAccessKeys
            path="/digital-journey/client"
            render={(routeProps) => <ClientPage {...routeProps} {...props} />}
          />
          <RouteWithAccessKeys
            path="/digital-journey/summary"
            render={(routeProps) => <SummaryPage {...routeProps} {...props} />}
          />
          <RouteWithAccessKeys
            path="/digital-journey/aplazame-confirmation"
            render={(routeProps) => <AplazameConfirmationPage {...routeProps} {...props} />}
          />
          <RouteWithAccessKeys
            path="/digital-journey/apz-checkout"
            render={(routeProps) => <ApzCheckoutPage {...routeProps} {...props} />}
          />
          <RouteWithAccessKeys
            path="/digital-journey/final"
            render={(routeProps) => <FinalPage {...routeProps} {...props} />}
          />
          <RouteWithAccessKeys
            path="/digital-journey/pending-score"
            render={(routeProps) => <PendingScorePage {...routeProps} {...props} />}
          />
          <RouteWithAccessKeys
            path="/digital-journey/identification"
            render={(routeProps) => <IdentificationPage {...routeProps} {...props} />}
          />
          <RouteWithAccessKeys
            path="/digital-journey/acceptance"
            render={(routeProps) => <AcceptancePage {...routeProps} {...props} />}
          />
          <RouteWithAccessKeys
            path="/digital-journey/cb"
            render={(routeProps) => <CbPage {...routeProps} {...props} />}
          />
          <RouteWithAccessKeys
            path="/digital-journey/paymentko"
            render={(routeProps) => <PaymentKOPage {...routeProps} {...props} />}
          />
          <RouteWithAccessKeys
            path="/digital-journey/payment-validation"
            render={(routeProps) => <AdyenPaymentValidationPage {...routeProps} {...props} />}
          />
          <RouteWithAccessKeys
            path="/digital-journey/fail"
            render={(routeProps) => <FailPage {...routeProps} {...props} />}
          />
          <RouteWithAccessKeys
            path="/digital-journey/maintenance"
            render={(routeProps) => <MaintenancePage {...routeProps} {...props} />}
          />
          <RouteWithAccessKeys
            path="/digital-journey/score-ko"
            render={(routeProps) => <ScoreKOPage {...routeProps} {...props} />}
          />
          <RouteWithAccessKeys
            path="/digital-journey/netheos"
            render={(routeProps) => <NetheosPage {...routeProps} {...props} />}
          />
          <RouteWithAccessKeys
            path="/digital-journey/signature-paused"
            render={(routeProps) => <ComeBackLaterPage {...routeProps} {...props} />}
          />

          <RouteWithAccessKeys
            path="/digital-journey/order"
            render={(routeProps) => <OrderPage {...routeProps} {...props} />}
          />
          <RouteWithAccessKeys
            path="/digital-journey/loader"
            render={(routeProps) => <LoaderPage {...routeProps} {...props} />}
          />
        </ScrollToTop>
      </Switch>
    </>
  )
}
